import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useContext, useEffect, useRef } from "react";
import omit from "lodash/omit";
import { FieldsetContext } from "../form/fieldset/Fieldset";
import { useCombineRefs } from "../hooks/useCombineRefs";
import * as Styled from "./BinarySelect.styled";
/**
 * A common component crossing Radio button and Checkbox
 */
export const BinarySelect = forwardRef(({ ariaLabel, ariaLabelledby, checkStyle, checked, defaultChecked, disabled: disabledProp, display = "block", hasError, id, isRadio, label, name, onChange, value, shouldVisuallyHideLabel, inputProps, inputRef: inputRefProp, ...props }, ref) => {
    const fieldsetOptions = useContext(FieldsetContext);
    const disabled = disabledProp || fieldsetOptions.disabled;
    const styleProps = {
        checkStyle,
        checked,
        disabled,
        hasError,
        isRadio,
        display,
        shouldVisuallyHideLabel
    };
    const inputRefInternal = useRef(null);
    const inputRef = useCombineRefs(inputRefInternal, inputRefProp);
    useEffect(() => {
        if (inputRefInternal?.current) {
            inputRefInternal.current.indeterminate = checkStyle === "indeterminate";
        }
    }, [checkStyle]);
    return (_jsxs(Styled.Container, { ref: ref, htmlFor: id, "data-testid": "BinarySelect", ...styleProps, ...props, children: [_jsx(Styled.Input, { ref: inputRef, type: isRadio ? "radio" : "checkbox", defaultChecked: defaultChecked, indeterminate: checkStyle === "indeterminate", impliedChecked: checkStyle === "impliedChecked", name: name, value: value, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, onChange: onChange, id: id, ...styleProps, ...inputProps }), _jsx(Styled.Control, { ...styleProps, children: _jsx(Styled.Toggle, { ...styleProps }) }), label && _jsx(Styled.Label, { ...styleProps, children: label })] }));
});
BinarySelect.displayName = "BinarySelect";
const defaultProps = {
    disabled: false,
    hasError: false,
    isRadio: false,
    onChange: () => { },
    value: ""
};
BinarySelect.defaultProps = defaultProps;
export const BinarySelectCommonDefaultProps = omit(defaultProps, "isRadio");
